// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xhwoS","header":"styles_header__PELrh","gridItems":"styles_gridItems__rykmN","actions":"styles_actions__MOUiZ"};